import React, { DetailedHTMLProps, FocusEvent, InputHTMLAttributes, useState } from 'react';
import { StringInputViewModel } from '@sitecore-jss/sitecore-jss-forms';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import classNames from 'classnames';

import { useFormTheme } from '../../contexts/FormTheme/FormThemeContext';
import { JabraValidation } from '../../enums/jabraValidations';

interface JabraInputProps
  extends DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  jssMetadata: ValueFieldProps<StringInputViewModel>;
}

const JabraInput: React.FC<JabraInputProps> = ({ jssMetadata, ...htmlProps }) => {
  const { field, errors, tracker } = jssMetadata;
  const { maxLength, minLength, validationDataModels } = field.model;
  const [hasFocus, setHasFocus] = useState(false);
  const hasAnyError = !!errors?.length;
  const isStringLengthValidationOn = validationDataModels.some(
    (validation) => validation.itemId === JabraValidation.StringLengthValidator
  );

  const { secondaryTextColor } = useFormTheme();

  const onFocus = (event: FocusEvent<HTMLInputElement>) => {
    tracker.onFocusField(field, event?.target?.value);
    setHasFocus(true);
  };
  const onBlur = (event: FocusEvent<HTMLInputElement>) => {
    tracker.onBlurField(field, event?.target?.value);
    setHasFocus(false);
  };

  return (
    <input
      {...htmlProps}
      className={classNames(
        `h-[3.25rem] w-full rounded-lg border px-4 py-3 text-lg text-black outline-none placeholder:${secondaryTextColor}`,
        {
          'border-gray-100 bg-white': !hasFocus && !hasAnyError,
          'border-yellow bg-white': hasFocus,
          'border-error bg-error/20': hasAnyError,
        },
        htmlProps.className
      )}
      maxLength={isStringLengthValidationOn ? maxLength : undefined}
      minLength={isStringLengthValidationOn ? minLength : undefined}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  );
};

export default JabraInput;
